// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";

const Imported$pmodules = {};

const Google = Caml_module.init_mod([
      "proto/third_party/google_wkt/gen/google_protobuf_struct.ml",
      169,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "NullValue"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Struct"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Value"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ListValue"
              ]
            ]
          },
          "Protobuf"
        ]]
    });

const Protobuf = Caml_module.init_mod([
      "proto/third_party/google_wkt/gen/google_protobuf_struct.ml",
      310,
      8
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "NullValue"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Struct"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Value"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ListValue"
        ]
      ]
    });

const NullValue = Caml_module.init_mod([
      "proto/third_party/google_wkt/gen/google_protobuf_struct.ml",
      326,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const Struct = Caml_module.init_mod([
      "proto/third_party/google_wkt/gen/google_protobuf_struct.ml",
      375,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const Value = Caml_module.init_mod([
      "proto/third_party/google_wkt/gen/google_protobuf_struct.ml",
      435,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListValue = Caml_module.init_mod([
      "proto/third_party/google_wkt/gen/google_protobuf_struct.ml",
      508,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".google.protobuf.NullValue";
}

function to_int(param) {
  return 0;
}

function from_int_exn(n) {
  if (n !== 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return /* NULL_VALUE */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  return "NULL_VALUE";
}

function from_string_exn(s) {
  if (s === "NULL_VALUE") {
    return /* NULL_VALUE */0;
  } else {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_name",
                VAL: s
              });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, NullValue, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

function name$1(param) {
  return ".google.protobuf.Struct";
}

function make(fieldsOpt, param) {
  const fields = fieldsOpt !== undefined ? fieldsOpt : /* [] */0;
  return {
          fields: fields
        };
}

const merge_fields = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.map([
          [
            1,
            "fields",
            "fields"
          ],
          [
            Ocaml_protoc_plugin__Spec.string,
            Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    2,
                    "value",
                    "value"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: Value.name,
                        make: Value.make,
                        from_proto: Value.from_proto,
                        from_proto_exn: Value.from_proto_exn,
                        to_proto: Value.to_proto,
                        to_proto$p: Value.to_proto$p,
                        merge: Value.merge,
                        to_json: Value.to_json,
                        from_json_exn: Value.from_json_exn,
                        from_json: Value.from_json
                      })
                ])
          ]
        ]));

function merge(t1, t2) {
  return {
          fields: Curry._2(merge_fields, t1.fields, t2.fields)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.map([
                  [
                    1,
                    "fields",
                    "fields"
                  ],
                  [
                    Ocaml_protoc_plugin__Spec.string,
                    Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            2,
                            "value",
                            "value"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: Value.name,
                                make: Value.make,
                                from_proto: Value.from_proto,
                                from_proto_exn: Value.from_proto_exn,
                                to_proto: Value.to_proto,
                                to_proto$p: Value.to_proto$p,
                                merge: Value.merge,
                                to_json: Value.to_json,
                                from_json_exn: Value.from_json_exn,
                                from_json: Value.from_json
                              })
                        ])
                  ]
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._2(serialize, writer, param.fields);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(fields) {
  return {
          fields: fields
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.protobuf.Struct", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.fields);
  };
}

function constructor$1(fields) {
  return {
          fields: fields
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.protobuf.Struct", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Struct, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name$1,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$2(param) {
  return ".google.protobuf.Value";
}

function make$1(kindOpt, param) {
  const kind = kindOpt !== undefined ? kindOpt : "not_set";
  return {
          kind: kind
        };
}

const merge_oneof_kind__Null_value = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.$$enum(NullValue)
        ]));

const merge_oneof_kind__Number_value = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.$$double
        ]));

const merge_oneof_kind__String_value = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_oneof_kind__Bool_value = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.bool
        ]));

const merge_oneof_kind__Struct_value = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: Struct.name,
                make: Struct.make,
                from_proto: Struct.from_proto,
                from_proto_exn: Struct.from_proto_exn,
                to_proto: Struct.to_proto,
                to_proto$p: Struct.to_proto$p,
                merge: Struct.merge,
                to_json: Struct.to_json,
                from_json_exn: Struct.from_json_exn,
                from_json: Struct.from_json
              })
        ]));

const merge_oneof_kind__List_value = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ListValue.name,
                make: ListValue.make,
                from_proto: ListValue.from_proto,
                from_proto_exn: ListValue.from_proto_exn,
                to_proto: ListValue.to_proto,
                to_proto$p: ListValue.to_proto$p,
                merge: ListValue.merge,
                to_json: ListValue.to_json,
                from_json_exn: ListValue.from_json_exn,
                from_json: ListValue.from_json
              })
        ]));

function merge$1(t1, t2) {
  const match = t1.kind;
  const match$1 = t2.kind;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Number_value") {
      if (typeof match$1 === "string" || match$1.NAME !== "Number_value") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Number_value",
          VAL: Curry._2(merge_oneof_kind__Number_value, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "List_value") {
      if (typeof match$1 === "string" || match$1.NAME !== "List_value") {
        exit = 1;
      } else {
        tmp = {
          NAME: "List_value",
          VAL: Curry._2(merge_oneof_kind__List_value, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "String_value") {
      if (typeof match$1 === "string" || match$1.NAME !== "String_value") {
        exit = 1;
      } else {
        tmp = {
          NAME: "String_value",
          VAL: Curry._2(merge_oneof_kind__String_value, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Null_value") {
      if (typeof match$1 === "string" || match$1.NAME !== "Null_value") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Null_value",
          VAL: Curry._2(merge_oneof_kind__Null_value, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Struct_value") {
      if (typeof match$1 === "string" || match$1.NAME !== "Struct_value") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Struct_value",
          VAL: Curry._2(merge_oneof_kind__Struct_value, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Bool_value" && !(typeof match$1 === "string" || match$1.NAME !== "Bool_value")) {
      tmp = {
        NAME: "Bool_value",
        VAL: Curry._2(merge_oneof_kind__Bool_value, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
          kind: tmp
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
                  {
                    hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                          [
                            1,
                            "null_value",
                            "nullValue"
                          ],
                          Ocaml_protoc_plugin__Spec.$$enum(NullValue),
                          [
                            (function (v) {
                                return {
                                        NAME: "Null_value",
                                        VAL: v
                                      };
                              }),
                            (function (param) {
                                if (typeof param === "string") {
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                            _1: "Cannot destruct given oneof"
                                          });
                                }
                                if (param.NAME === "Null_value") {
                                  return param.VAL;
                                }
                                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                          MEL_EXN_ID: Stdlib.Invalid_argument,
                                          _1: "Cannot destruct given oneof"
                                        });
                              })
                          ]
                        ]),
                    tl: {
                      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                            [
                              2,
                              "number_value",
                              "numberValue"
                            ],
                            Ocaml_protoc_plugin__Spec.$$double,
                            [
                              (function (v) {
                                  return {
                                          NAME: "Number_value",
                                          VAL: v
                                        };
                                }),
                              (function (param) {
                                  if (typeof param === "string") {
                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                              MEL_EXN_ID: Stdlib.Invalid_argument,
                                              _1: "Cannot destruct given oneof"
                                            });
                                  }
                                  if (param.NAME === "Number_value") {
                                    return param.VAL;
                                  }
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                            _1: "Cannot destruct given oneof"
                                          });
                                })
                            ]
                          ]),
                      tl: {
                        hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                              [
                                3,
                                "string_value",
                                "stringValue"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              [
                                (function (v) {
                                    return {
                                            NAME: "String_value",
                                            VAL: v
                                          };
                                  }),
                                (function (param) {
                                    if (typeof param === "string") {
                                      throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                MEL_EXN_ID: Stdlib.Invalid_argument,
                                                _1: "Cannot destruct given oneof"
                                              });
                                    }
                                    if (param.NAME === "String_value") {
                                      return param.VAL;
                                    }
                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                              MEL_EXN_ID: Stdlib.Invalid_argument,
                                              _1: "Cannot destruct given oneof"
                                            });
                                  })
                              ]
                            ]),
                        tl: {
                          hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                [
                                  4,
                                  "bool_value",
                                  "boolValue"
                                ],
                                Ocaml_protoc_plugin__Spec.bool,
                                [
                                  (function (v) {
                                      return {
                                              NAME: "Bool_value",
                                              VAL: v
                                            };
                                    }),
                                  (function (param) {
                                      if (typeof param === "string") {
                                        throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                  MEL_EXN_ID: Stdlib.Invalid_argument,
                                                  _1: "Cannot destruct given oneof"
                                                });
                                      }
                                      if (param.NAME === "Bool_value") {
                                        return param.VAL;
                                      }
                                      throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                MEL_EXN_ID: Stdlib.Invalid_argument,
                                                _1: "Cannot destruct given oneof"
                                              });
                                    })
                                ]
                              ]),
                          tl: {
                            hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                  [
                                    5,
                                    "struct_value",
                                    "structValue"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: Struct.name,
                                        make: Struct.make,
                                        from_proto: Struct.from_proto,
                                        from_proto_exn: Struct.from_proto_exn,
                                        to_proto: Struct.to_proto,
                                        to_proto$p: Struct.to_proto$p,
                                        merge: Struct.merge,
                                        to_json: Struct.to_json,
                                        from_json_exn: Struct.from_json_exn,
                                        from_json: Struct.from_json
                                      }),
                                  [
                                    (function (v) {
                                        return {
                                                NAME: "Struct_value",
                                                VAL: v
                                              };
                                      }),
                                    (function (param) {
                                        if (typeof param === "string") {
                                          throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                    MEL_EXN_ID: Stdlib.Invalid_argument,
                                                    _1: "Cannot destruct given oneof"
                                                  });
                                        }
                                        if (param.NAME === "Struct_value") {
                                          return param.VAL;
                                        }
                                        throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                  MEL_EXN_ID: Stdlib.Invalid_argument,
                                                  _1: "Cannot destruct given oneof"
                                                });
                                      })
                                  ]
                                ]),
                            tl: {
                              hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                    [
                                      6,
                                      "list_value",
                                      "listValue"
                                    ],
                                    Ocaml_protoc_plugin__Spec.message({
                                          name: ListValue.name,
                                          make: ListValue.make,
                                          from_proto: ListValue.from_proto,
                                          from_proto_exn: ListValue.from_proto_exn,
                                          to_proto: ListValue.to_proto,
                                          to_proto$p: ListValue.to_proto$p,
                                          merge: ListValue.merge,
                                          to_json: ListValue.to_json,
                                          from_json_exn: ListValue.from_json_exn,
                                          from_json: ListValue.from_json
                                        }),
                                    [
                                      (function (v) {
                                          return {
                                                  NAME: "List_value",
                                                  VAL: v
                                                };
                                        }),
                                      (function (param) {
                                          if (typeof param === "string") {
                                            throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                      MEL_EXN_ID: Stdlib.Invalid_argument,
                                                      _1: "Cannot destruct given oneof"
                                                    });
                                          }
                                          if (param.NAME === "List_value") {
                                            return param.VAL;
                                          }
                                          throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                    MEL_EXN_ID: Stdlib.Invalid_argument,
                                                    _1: "Cannot destruct given oneof"
                                                  });
                                        })
                                    ]
                                  ]),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  },
                  (function (param) {
                      if (typeof param === "string") {
                        return Stdlib.failwith("Impossible case");
                      }
                      const variant = param.NAME;
                      if (variant === "List_value") {
                        return 5;
                      } else if (variant === "String_value") {
                        return 2;
                      } else if (variant === "Null_value") {
                        return 0;
                      } else if (variant === "Struct_value") {
                        return 4;
                      } else if (variant === "Bool_value") {
                        return 3;
                      } else {
                        return 1;
                      }
                    })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.kind);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(kind) {
  return {
          kind: kind
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.protobuf.Value", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kind);
  };
}

function constructor$3(kind) {
  return {
          kind: kind
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.protobuf.Value", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Value, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$2,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$3(param) {
  return ".google.protobuf.ListValue";
}

function make$2(valuesOpt, param) {
  const values = valuesOpt !== undefined ? valuesOpt : /* [] */0;
  return {
          values: values
        };
}

const merge_values = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "values",
            "values"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: Value.name,
                make: Value.make,
                from_proto: Value.from_proto,
                from_proto_exn: Value.from_proto_exn,
                to_proto: Value.to_proto,
                to_proto$p: Value.to_proto$p,
                merge: Value.merge,
                to_json: Value.to_json,
                from_json_exn: Value.from_json_exn,
                from_json: Value.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$2(t1, t2) {
  return {
          values: Curry._2(merge_values, t1.values, t2.values)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "values",
                    "values"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: Value.name,
                        make: Value.make,
                        from_proto: Value.from_proto,
                        from_proto_exn: Value.from_proto_exn,
                        to_proto: Value.to_proto,
                        to_proto$p: Value.to_proto$p,
                        merge: Value.merge,
                        to_json: Value.to_json,
                        from_json_exn: Value.from_json_exn,
                        from_json: Value.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.values);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(values) {
  return {
          values: values
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.protobuf.ListValue", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.values);
  };
}

function constructor$5(values) {
  return {
          values: values
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.protobuf.ListValue", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListValue, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$3,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "NullValue"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Struct"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Value"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ListValue"
        ]
      ]
    }, Protobuf, {
      NullValue: NullValue,
      Struct: Struct,
      Value: Value,
      ListValue: ListValue
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "NullValue"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Struct"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Value"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ListValue"
              ]
            ]
          },
          "Protobuf"
        ]]
    }, Google, {
      Protobuf: Protobuf
    });

export {
  Imported$pmodules ,
  Google ,
}
/* Google Not a pure module */
